<template>
    <div>
        <BookingBack title="" :textColor="'#333333'" :isCenter="true"/>
        <div class="payOrder">
            <!-- 顶部日期时间信息 -->
            <div class="dateHeader" v-if="orderData && orderData.length > 0">
                <div class="dateText">{{ formatTimestamp(orderData[0].start_time, 'MMMM, dddd DD YYYY') }}</div>
                <div class="timeText">{{ formatTimestamp(orderData[0].start_time, 'hh:mm A') }} -{{ formatTimestamp(orderData[orderData.length - 1].end_time, 'hh:mm A') }} ({{ getTotalMinutes() }}min)</div>
                <div class="shopName">{{ shopName }}</div>
            </div>
             <div class="orderList">
                <template v-for="(item, index) in orderData">
                    <PayOrderList
                        :key="'service-' + (item.id || index)"
                        :list="item"
                    />
                    <div
                        v-if="index < orderData.length - 1"
                        :key="'sep-' + index"
                        class="serviceSeparator"
                    >
                        <div class="serviceSeparatorLine"></div>
                    </div>
                </template>
                <van-divider :style="{width:'100%',color: '#333333', borderColor: '#cccccc' }"></van-divider>
                <div class="priceBreakdown">
                    <div><span>Subtotal</span><span>${{ quote ? quote.subtotal : totalPrice.toFixed(2) }}</span></div>
                    <div><span>Processing Fee</span><span>${{ quote ? quote.processing_fee : '0.00' }}</span></div>
                    <div><span>Online Tip</span><span>${{ quote ? quote.tip_fee : '0.00' }}</span></div>
                    <div class="priceTotal"><span>Total</span><span>${{ quote ? quote.order_total : totalPrice.toFixed(2) }}</span></div>
                    <div class="quoteLoading" v-if="quoteLoading">Updating total...</div>
                </div>
            </div>
            <van-field v-model="queryForm.buyer_remark"  placeholder="Note (optional)"  style="margin-top:1rem;border:1px solid #CCCCCC;border-radius:8px"/>
            <van-divider :style="{ borderColor: '#CCCCCC' }" dashed></van-divider>
            <div class="payContent">
                <div style="color:#666666;margin-bottom:1rem">Select Payment Method</div>
                <div class="payMethods">
                    <div class="payItem" v-for="item in visiblePayMethods" :key="item.id" @click="queryForm.order_type = item.id">
                        <div>{{ item.label }}</div>
                        <div class="round" :class="{'active':item.id == queryForm.order_type}"></div>
                    </div>
                    <div class="tipSection" v-if="queryForm.order_type === 2">
                        <div class="tipTitle">Online Tip</div>
                        <div class="tipOptions">
                            <button type="button" v-for="item in tipOptions" :key="item.type + item.rate"
                                :class="{ active: tipType === item.type && tipRate === item.rate }"
                                @click="selectTip(item)">{{ item.label }}</button>
                        </div>
                        <input v-if="tipType === 'custom'" v-model="customTipAmount" inputmode="decimal"
                            class="customTipInput" placeholder="Custom tip amount" />
                    </div>
                    <!-- Gift Card支付区域 -->
                    <div class="giftCardSection" v-if="queryForm.order_type == 3">
                        <div class="giftCardModeTabs">
                            <button
                                type="button"
                                class="giftCardModeTab"
                                :class="{ active: giftCardPaymentMode === 'wallet' }"
                                @click="selectGiftCardPaymentMode('wallet')"
                            >My Gift Cards</button>
                            <button
                                type="button"
                                class="giftCardModeTab"
                                :class="{ active: giftCardPaymentMode === 'direct' }"
                                @click="selectGiftCardPaymentMode('direct')"
                            >Use Another Gift Card</button>
                        </div>

                        <div v-if="giftCardPaymentMode === 'wallet'">
                            <div class="balanceInfo" v-if="selectedCard">
                                <div>
                                    <div class="selectedCardNumber">{{ formatCardNumber(selectedCard.card_no) }}</div>
                                    <span class="balanceLabel">Balance: ${{ formatBalance(selectedCard.balance) }}</span>
                                </div>
                            </div>
                            <div class="selectFromWallet" @click="selectFromWallet">
                                {{ selectedCard ? 'Choose another gift card' : 'Select from card wallet' }}
                            </div>
                        </div>

                        <div v-else class="directGiftCardFields">
                            <input
                                type="text"
                                inputmode="numeric"
                                v-model="giftCardNo"
                                placeholder="Enter gift card number"
                                class="cardInput"
                                maxlength="50"
                            />
                            <input
                                type="password"
                                inputmode="numeric"
                                v-model="giftCardPin"
                                @input="filterGiftCardPin"
                                placeholder="Enter 6-digit PIN"
                                class="cardInput"
                                maxlength="6"
                                autocomplete="off"
                            />
                            <div class="directGiftCardHint">If the balance is insufficient, you will pay the rest with Stripe.</div>
                        </div>

                        <div class="errorTip" v-if="giftCardError">
                            <span class="errorIcon">!</span>
                            <span>{{ giftCardError }}</span>
                        </div>
                        <div class="giftCardTipNotice">Online tipping isn’t available with gift card payment. You may tip at the store.</div>
                    </div>
                    <van-field v-model="queryForm.mobile"  placeholder="Please enter contact info" />
                </div>
            </div>
        </div>
        <div class="placeBox">
            <div class="processingAgreement">By placing this order, you agree to the Processing Fee and our Payment Terms.</div>
            <div class="placeBtn">
                <div class="btn" :class="{ disabled: submitting || quoteLoading || !quote }" @click="handlePay">Confirm Order</div>
            </div>
        </div>
        <!-- 卡包选择弹窗 -->
        <van-popup
            v-model="showWalletPopup"
            round
            closeable
            position="bottom"
            :style="{ maxHeight: '70%', paddingBottom: '1rem' }"
        >
            <div class="walletPopup">
                <div class="walletTitle">Gift Card Payment</div>
                <div class="walletLoading" v-if="walletLoading">Loading...</div>
                <div class="walletEmpty" v-else-if="walletCards.length === 0">No available gift cards</div>
                <div class="walletList" v-else>
                    <div
                        class="walletCard"
                        :class="card.cardType"
                        v-for="card in walletCards"
                        :key="card.id"
                        @click="handleSelectCard(card)"
                    >
                        <div class="cardHeader">
                            <span class="cardTag">Gift Card</span>
                            <div class="cardCopy" @click.stop="copyCardNo(card.card_no)">
                                <svg viewBox="0 0 24 24" width="20" height="20">
                                    <rect x="9" y="9" width="10" height="10" rx="2" ry="2" fill="none" stroke="#ffffff" stroke-width="2"></rect>
                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" fill="none" stroke="#ffffff" stroke-width="2"></path>
                                </svg>
                            </div>
                        </div>
                        <div class="cardNumber">{{ formatCardNumber(card.card_no) }}</div>
                        <div class="cardShopName">{{ card.shopName }}</div>
                        <div class="cardAddress">{{ card.address }}</div>
                        <div class="cardBottom">
                            <span class="cardLabel">Balance</span>
                            <span class="cardAmount">${{ formatBalance(card.balance) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import BookingBack from '@/components/Booking/back.vue'
import PayOrderList from '@/components/Pay/orderList.vue'
import myMixin from '@/utils/myMixin'
import { Toast  } from 'vant';
import { startStripeCheckout, getAbsoluteHashUrl } from '@/utils/stripeCheckout'
export default {
    name:'PayOrder',
    mixins: [myMixin],
    data(){
        return {
            totalPrice:0,
            orderData:null,
            shopName: '',
            giftCardPaymentMode: 'wallet',
            giftCardNo:'',
            giftCardPin:'',
            giftCardError:'',
            selectedCard: null,
            showWalletPopup: false,
            walletLoading: false,
            walletCards: [],
            submitting: false,
            quote: null,
            quoteLoading: false,
            quoteTimer: null,
            quoteRequestId: 0,
            tipType: 'none',
            tipRate: '0',
            customTipAmount: '',
            tipOptions: [
                { type: 'none', rate: '0', label: 'No Tip' },
                { type: 'percent', rate: '15', label: '15%' },
                { type: 'percent', rate: '20', label: '20%' },
                { type: 'percent', rate: '25', label: '25%' },
                { type: 'custom', rate: '0', label: 'Custom' }
            ],
            payMethods:[
                {id:2,label:'Stripe Prepay'},
                {id:1,label:'Pay at Store'},
                {id:3,label:'Gift Card'},
                {id:4,label:'CSR Assisted Order'},
            ],
            // 当前用户信息（用于权限判断，例如 is_replace）
            currentUserInfo: null,
            queryForm:{
                buyer_remark:'',
                mobile:'',
                order_type:1,
                // service:JSON.stringify([{service_id:5,start_time:"2025-09-02 10:00:00",end_time:"2025-09-02 11:00:00",technician_id:1}])
                service:''
            },
            merchantTimezone: null
        }
    },
    components:{
        BookingBack,
        PayOrderList
    },
    mounted(){
        // 检测是否是从Stripe支付CancelBack
        if (this.$route.query.pay === 'cancel') {
            Toast.fail('Payment cancelled')
            // 跳转到订单列表页面
            this.$router.replace('/order?pay=cancel')
            return
        }
        // 读取缓存的用户信息；如果没有就补拉一次
        this.loadCurrentUserInfo()
        try {
            const parsed = JSON.parse(this.$route.query.orderData) || []
            if (Array.isArray(parsed) && parsed.length > 1) {
                parsed.sort((a, b) => this.parseTime(a.start_time) - this.parseTime(b.start_time))
            }
            this.orderData = parsed
            this.$nextTick(() => this.scheduleQuote())
        } catch (e) {
            this.orderData = []
        }
        // 获取Store Name
        if (this.orderData && this.orderData.length > 0 && this.orderData[0].shop_supplier_id) {
            this.getShopName(this.orderData[0].shop_supplier_id)
        }
    },
    computed: {
        // is_replace: 0=普通用户（不展示CSR Assisted Order），1=客服（展示）
        visiblePayMethods() {
            const isReplace = this.currentUserInfo && typeof this.currentUserInfo.is_replace !== 'undefined' ? Number(this.currentUserInfo.is_replace)
                : 0
            const allowServiceOrder = isReplace === 1
            return allowServiceOrder ? this.payMethods : this.payMethods.filter(m => m.id !== 4)
        },
        // 从当前订单服务中取得真实商家 ID，钱包查询不能使用固定值。
        currentShopSupplierId() {
            const firstService = Array.isArray(this.orderData) ? this.orderData[0] : null
            return firstService ? Number(firstService.shop_supplier_id || 0) : 0
        }
    },
    watch:{
        orderData: {
            handler(newVal, oldVal) {
                this.totalPrice = 0
                for(let i in newVal ){
                    this.totalPrice += Number(newVal[i].price) || Number(newVal[i].total_price)
                }
            },
            deep: true, // 深度监听
            // immediate: true // 初始化时立即执行一次
        },
        'queryForm.order_type': {
            handler(newVal) {
                this.resetTip()
                // 切换Payment Method时清空礼品卡信息
                if (newVal !== 3) {
                    this.clearDirectGiftCardCredentials()
                    this.giftCardPaymentMode = 'wallet'
                    this.selectedCard = null
                }
                this.scheduleQuote()
            }
        },
        // 直接支付修改卡号后必须重新输入 PIN，避免凭据错配。
        giftCardNo(newVal, oldVal) {
            if (this.giftCardPaymentMode === 'direct' && newVal !== oldVal) {
                this.giftCardPin = ''
                this.giftCardError = ''
                this.scheduleQuote()
            }
        },
        giftCardPin() {
            this.scheduleQuote()
        },
        customTipAmount() {
            if (this.tipType === 'custom') this.scheduleQuote()
        }
    },
    beforeDestroy() {
        clearTimeout(this.quoteTimer)
        // 离开支付页时清除 PIN 明文。
        this.clearDirectGiftCardCredentials()
    },
    methods:{
        // 将小费恢复为默认的 No Tip。
        resetTip() {
            this.tipType = 'none'
            this.tipRate = '0'
            this.customTipAmount = ''
        },
        // 选择小费类型并刷新服务端报价。
        selectTip(item) {
            this.tipType = item.type
            this.tipRate = item.rate
            if (item.type !== 'custom') this.customTipAmount = ''
            this.scheduleQuote()
        },
        // 构建服务端校验使用的预约服务参数。
        buildServicePayload() {
            const data = Array.isArray(this.orderData) ? this.orderData : []
            return JSON.stringify(data.map(item => ({
                service_id: item.id || item.service_id,
                technician_id: item.technician ? item.technician.id : (item.technician_id || 0),
                start_time: this.formatTimeForApi(item.start_time),
                end_time: this.formatTimeForApi(item.end_time)
            })))
        },
        // 构建报价和正式下单共用的计费参数。
        buildPricingParams() {
            const params = {
                order_type: this.queryForm.order_type,
                service: this.buildServicePayload(),
                tip_type: this.tipType,
                tip_rate: this.tipRate,
                custom_tip_amount: this.customTipAmount
            }
            if (this.queryForm.order_type === 3) {
                params.gift_card_payment_mode = this.giftCardPaymentMode
                if (this.giftCardPaymentMode === 'wallet' && this.selectedCard) {
                    params.gift_card_instance_id = this.selectedCard.gift_card_instance_id
                } else if (this.giftCardPaymentMode === 'direct') {
                    params.gift_card_number = String(this.giftCardNo || '').replace(/\s/g, '')
                    params.gift_card_pin = this.giftCardPin
                }
            }
            return params
        },
        // 判断当前输入是否足以发起报价请求。
        canRequestQuote() {
            if (!Array.isArray(this.orderData) || this.orderData.length === 0) return false
            if (this.queryForm.order_type !== 3) return true
            if (this.giftCardPaymentMode === 'wallet') return !!this.selectedCard
            return !!String(this.giftCardNo || '').replace(/\s/g, '') && /^\d{6}$/.test(this.giftCardPin)
        },
        // 作废旧报价并防抖获取新报价。
        scheduleQuote() {
            this.quote = null
            this.quoteRequestId += 1
            this.quoteLoading = false
            clearTimeout(this.quoteTimer)
            if (!this.canRequestQuote()) return
            this.quoteTimer = setTimeout(() => this.requestQuote(), 300)
        },
        // 获取服务端最终报价，并忽略已过期的并发响应。
        async requestQuote() {
            const requestId = ++this.quoteRequestId
            this.quoteLoading = true
            try {
                const res = await this.$api.quoteServiceOrder(this.buildPricingParams())
                if (requestId !== this.quoteRequestId) return
                if (res.code === 1) {
                    this.quote = res.data
                    this.giftCardError = ''
                } else {
                    this.quote = null
                    if (this.queryForm.order_type === 3) this.giftCardError = res.msg || 'Unable to calculate gift card payment'
                }
            } catch (error) {
                if (requestId === this.quoteRequestId) this.quote = null
            } finally {
                if (requestId === this.quoteRequestId) this.quoteLoading = false
            }
        },
        // 切换钱包卡和直接支付，并清除上一种方式的敏感状态。
        selectGiftCardPaymentMode(mode) {
            if (this.giftCardPaymentMode === mode) return
            this.giftCardPaymentMode = mode
            this.selectedCard = null
            this.clearDirectGiftCardCredentials()
            this.scheduleQuote()
        },
        // 清除直接支付卡号、PIN 和错误提示。
        clearDirectGiftCardCredentials() {
            this.giftCardNo = ''
            this.giftCardPin = ''
            this.giftCardError = ''
        },
        // PIN 仅保留六位数字，并保持字符串形式以保留前导零。
        filterGiftCardPin() {
            this.giftCardPin = String(this.giftCardPin || '').replace(/\D/g, '').slice(0, 6)
        },
        loadCurrentUserInfo() {
            // 先读本地缓存
            try {
                const cached = localStorage.getItem('userInfo')
                if (cached) {
                    this.currentUserInfo = JSON.parse(cached)
                }
            } catch (e) {
                // ignore
            }
            // 如果没有缓存，再请求一次
            if (!this.currentUserInfo) {
                this.$api.getUserDetail().then(res => {
                    if (res && res.code === 1 && res.data) {
                        this.currentUserInfo = res.data.userInfo || {}
                        try {
                            localStorage.setItem('userInfo', JSON.stringify(this.currentUserInfo || {}))
                            localStorage.setItem('userDetail', JSON.stringify(res.data || {}))
                        } catch (e) {
                            // ignore
                        }
                        // 如果当前选中了“CSR Assisted Order”但用户无权限，则回退到“Pay at Store”
                        if (Number(this.currentUserInfo.is_replace) !== 1 && this.queryForm.order_type === 4) {
                            this.queryForm.order_type = 1
                        }
                    }
                }).catch(() => {})
            } else {
                // 已有缓存，也做一次兜底回退
                if (Number(this.currentUserInfo.is_replace) !== 1 && this.queryForm.order_type === 4) {
                    this.queryForm.order_type = 1
                }
            }
        },
        parseTime(time) {
            if (!time) return 0
            if (typeof time === 'number') {
                return time.toString().length === 10 ? time * 1000 : time
            }
            if (typeof time === 'string') {
                const timestamp = new Date(time).getTime()
                return isNaN(timestamp) ? 0 : timestamp
            }
            return 0
        },
        getTotalMinutes() {
            if (!this.orderData || this.orderData.length === 0) return 0
            let totalMin = 0
            for (let item of this.orderData) {
                let min = item.minute || 0
                if (item.hour > 0) {
                    min += item.hour * 60
                }
                totalMin += min
            }
            return totalMin
        },
        async getShopName(shop_supplier_id) {
            try {
                const res = await this.$api.getSupplierDetail({ shop_supplier_id })
                if (res.code === 1 && res.data && res.data.detail) {
                    this.shopName = res.data.detail.name || ''
                    this.merchantTimezone = res.data.detail.timezone || null
                }
            } catch (e) {
                console.error('Failed to get store name:', e)
            }
        },
        // 转换时间为接口需要的秒级时间戳
        formatTimeForApi(time) {
            if (!time) return ''
            if (typeof time === 'number') {
                return time.toString().length === 13 ? Math.floor(time / 1000) : time
            }
            if (/^\d+$/.test(String(time))) {
                const timestamp = Number(time)
                return String(time).length === 13 ? Math.floor(timestamp / 1000) : timestamp
            }
            if (this.merchantTimezone) {
                const ts = this.localTimeToTimestamp(String(time), this.merchantTimezone)
                if (ts !== null) return ts
            }
            const timestamp = new Date(String(time).replace(/-/g, '/')).getTime()
            if (isNaN(timestamp)) {
                return time
            }
            return Math.floor(timestamp / 1000)
        },
        formatCardNumber(cardNo) {
            if (!cardNo) return ''
            return cardNo.replace(/(\d{4})(?=\d)/g, '$1 ').trim()
        },
        formatBalance(balance) {
            const num = Number(balance || 0)
            return num.toFixed(2)
        },
        copyCardNo(cardNo) {
            if (!cardNo) return
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(cardNo).then(() => {
                    Toast.success('Card number copied')
                })
            } else {
                const input = document.createElement('input')
                input.value = cardNo
                document.body.appendChild(input)
                input.select()
                document.execCommand('copy')
                document.body.removeChild(input)
                Toast.success('Card number copied')
            }
        },
        selectFromWallet(){
            this.showWalletPopup = true
            this.fetchWalletCards()
        },
        async fetchWalletCards() {
            if (!this.currentShopSupplierId) {
                Toast.fail('Shop information not available')
                return
            }
            this.walletLoading = true
            try {
                const res = await this.$api.getUserGiftCardList({ shop_supplier_id: this.currentShopSupplierId })
                if (res.code === 1 && res.data && res.data.data) {
                    this.walletCards = res.data.data.map((item, index) => {
                        const instance = item.giftCardInstance || {}
                        const giftCard = instance.giftCard || {}
                        const supplier = giftCard.supplier || {}
                        return {
                            id: item.id,
                            binding_id: item.id,
                            gift_card_instance_id: instance.id,
                            card_no: instance.card_no || '',
                            balance: instance.balance || instance.initial_value || 0,
                            alias: item.alias || giftCard.name || 'Gift Card',
                            name: giftCard.name || '',
                            shopName: supplier.name || item.alias || giftCard.name || 'Store Name',
                            address: supplier.address || '',
                            cardType: index % 2 === 0 ? 'green-card' : 'blue-card'
                        }
                    })
                } else {
                    this.walletCards = []
                }
            } catch (error) {
                this.walletCards = []
                Toast.fail('Failed to load gift card list')
            } finally {
                this.walletLoading = false
            }
        },
        async handleSelectCard(card) {
            // 点击卡片后请求详情接口
            try {
                const res = await this.$api.getUserGiftCardDetail({
                    binding_id: card.binding_id,
                    card_no: card.card_no,
                    shop_supplier_id: this.currentShopSupplierId
                })
                if (res.code === 1 && res.data && res.data.data && res.data.data.length > 0) {
                    const detail = res.data.data[0]
                    const instance = detail.giftCardInstance || {}
                    const giftCard = instance.giftCard || {}
                    // 回填卡号andBalance
                    this.giftCardNo = instance.card_no || card.card_no
                    this.selectedCard = {
                        id: detail.id,
                        binding_id: detail.id,
                        gift_card_instance_id: instance.id,
                        card_no: instance.card_no,
                        balance: instance.balance || instance.initial_value || 0,
                        alias: detail.alias || giftCard.name || 'Gift Card'
                    }
                    this.giftCardError = ''
                } else {
                    // 如果详情接口没返回数据，使用列表数据
                    this.giftCardNo = card.card_no
                    this.selectedCard = card
                    this.giftCardError = ''
                }
            } catch (error) {
                // 请求失败时使用列表数据
                this.giftCardNo = card.card_no
                this.selectedCard = card
                this.giftCardError = ''
            }
            this.showWalletPopup = false
            this.scheduleQuote()
        },
        handlePay(){
            if (this.submitting || this.quoteLoading) return
            if (!Array.isArray(this.orderData) || this.orderData.length === 0) {
                Toast.fail('Please select service items')
                return
            }
            if (this.queryForm.order_type === 3) {
                if (this.giftCardPaymentMode === 'wallet') {
                    if (!this.selectedCard) {
                        Toast.fail('Please select a gift card')
                        return
                    }
                } else {
                    const cardNo = String(this.giftCardNo || '').replace(/\s/g, '')
                    if (!cardNo) {
                        this.giftCardError = 'Please enter a gift card number'
                        return
                    }
                    if (!/^\d{6}$/.test(this.giftCardPin)) {
                        this.giftCardError = 'Please enter a valid 6-digit PIN'
                        return
                    }
                    this.giftCardError = ''
                }
            }
            if (!this.quote) {
                Toast.fail('Please wait for the updated total and confirm again.')
                this.scheduleQuote()
                return
            }
            this.queryForm.service = this.buildServicePayload()
            this.submitOrder()
        },
        // 提交订单
        submitOrder() {
            if (this.submitting) return
            this.submitting = true
            const params = Object.assign(this.buildPricingParams(), {
                buyer_remark: this.queryForm.buyer_remark || '',
                mobile: this.queryForm.mobile || '',
                expected_processing_fee: this.quote.processing_fee,
                expected_tip_fee: this.quote.tip_fee,
                expected_order_total: this.quote.order_total,
                expected_stripe_pay_amount: this.quote.stripe_pay_amount
            })
            const requiresStripe = !!this.quote.requires_stripe
            const isDirectGiftCard = Number(this.queryForm.order_type) === 3 && this.giftCardPaymentMode === 'direct'
            if (requiresStripe) {
                params.success_url = getAbsoluteHashUrl('/order?pay=success')
                params.cancel_url = getAbsoluteHashUrl('/order?pay=cancel')
            }
            this.$api.payOrder(params).then(res=>{
                if(res.code == 1){
                    sessionStorage.removeItem('hwm_booking_calendar_draft')
                    // Stripe：直接访问后端返回的 Checkout URL
                    const payload = res || {}
                    const checkoutUrl = payload.data?.checkout_url
                    if (checkoutUrl) {
                        this.clearDirectGiftCardCredentials()
                        Toast.loading({ duration: 0, message: 'Redirecting to payment...', forbidClick: true })
                        startStripeCheckout({ checkoutUrl })
                          .catch((e) => {
                              console.error('Stripe redirect error:', e && e.message ? e.message : 'redirect failed')
                              Toast.clear()
                              Toast.fail((e && e.message) || 'Failed to redirect to payment')
                          })
                        return
                    }
                    if (requiresStripe) {
                        console.error('Stripe payment required, but backend did not return checkout_url.')
                        Toast.fail('Failed to get payment info. Please try again.')
                        return
                    }
                    this.clearDirectGiftCardCredentials()
                    Toast.success('Order placed successfully')
                    // 跳转到个人中心的Book页面
                    this.$router.push('/order')
                }else{
                    if(res.data && res.data.error_code === 'CHECKOUT_AMOUNT_CHANGED' && res.data.quote){
                        this.quote = res.data.quote
                        Toast.fail('The total changed. Please review it and confirm again.')
                        return
                    }
                    if(res.data && res.data.error_code === 'SLOT_NO_LONGER_AVAILABLE'){
                        // 时段冲突需要恢复预约草稿并重新选时，不能按普通支付失败留在本页。
                        Toast.fail(res.msg || 'This time is no longer available.')
                        this.$router.replace({path:'/booking',query:{restore:'1'}})
                        return
                    }
                    if (isDirectGiftCard) this.giftCardPin = ''
                    Toast.fail(res.msg || 'Order failed')
                }
            }).catch(err => {
                if (isDirectGiftCard) this.giftCardPin = ''
                console.error('Order failed:', err && err.message ? err.message : 'request failed')
                Toast.fail('Network error. Please try again.')
            }).finally(() => {
                this.submitting = false
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .dateHeader {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 1rem 0 1.5rem 0;
        .dateText {
            font-size: 1.125rem;
            font-weight: 500;
            color: #333;
        }
        .timeText {
            font-size: 1rem;
            color: #666;
            margin: 0.5rem 0;
        }
        .shopName {
            font-size: 0.875rem;
            color: #999;
        }
    }
    .priceBreakdown {
        display: flex;
        flex-direction: column;
        gap: .5rem;
        color: #555;
        > div {
            display: flex;
            justify-content: space-between;
        }
        .priceTotal {
            padding-top: .5rem;
            border-top: 1px solid #d6d6d6;
            color: #222;
            font-weight: 600;
        }
        .quoteLoading {
            justify-content: flex-end;
            color: #777;
            font-size: .75rem;
        }
    }
    .orderList{
        width: 100%;
        padding: 1rem;
        background: #F4F4F4;
        box-sizing: border-box;
        border-radius: .625rem;
    }
    .serviceSeparator{
        padding: 0.75rem 0;
    }
    .serviceSeparatorLine{
        width: 100%;
        height: 1px;
        background: #D6D6D6;
    }
    .placeBox{
        width: 100%;
        min-height: 7rem;
        .processingAgreement{
            padding: .75rem 1rem 4.5rem;
            color: #777;
            font-size: .75rem;
            line-height: 1.4;
        }
        .placeBtn{
            width: 100%;
            height:3.75rem;
            position: fixed;
            bottom: 0;
            background: #fff;
            padding: 0 1rem;
            box-sizing: border-box;
            .btn{
                width: 100%;
                height: 2.75rem;
                background: #1E3C3E;
                border-radius: .25rem;
                display: flex;
                align-items:center;
                justify-content: center;
                color: #fff;
                font-size: .875rem;
                &.disabled{
                    opacity: .6;
                    pointer-events: none;
                }
            }
        }
    }
    .payOrder{
        width: 100%;
        padding:1rem;
        box-sizing: border-box;
        .dateGroup{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 1.25rem;
            .year{
                color: #333333;
                font-weight: bold;
            }
            .time{
                color: #666666;
                margin: 0.5rem;
            }
            .serviceName{
                color: #999999;
                font-size: .875rem;
            }
        }
        .payContent{
            width: 100%;
            background: #F4F4F4;
            border-radius: .5rem;
            padding: 1rem;
            box-sizing: border-box;
            .payMethods{
                display: flex;
                flex-direction: column;
                .payItem{
                    width: 100%;
                    height: 2.5rem;
                    background: #fff;
                    border-radius: .25rem;
                    margin-bottom: 1rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 1rem;
                    box-sizing: border-box;
                    .round{
                        width: 1rem;
                        height: 1rem;
                        border-radius: 100%;
                        background: #fff;
                        border:1px solid #D9D9D9;
                        box-sizing: border-box;
                    }
                    .active{
                        border:4px solid #1E3C3E;
                    }
                }
                .tipSection{
                    padding: 1rem;
                    margin-bottom: 1rem;
                    border-radius: .75rem;
                    background: #fff;
                    .tipTitle{
                        margin-bottom: .75rem;
                        color: #333;
                        font-weight: 600;
                    }
                    .tipOptions{
                        display: flex;
                        flex-wrap: wrap;
                        gap: .5rem;
                        button{
                            min-width: 4.25rem;
                            padding: .625rem .75rem;
                            border: 1px solid #ccc;
                            border-radius: .5rem;
                            background: #fff;
                            color: #555;
                            &.active{
                                border-color: #1E3C3E;
                                background: #1E3C3E;
                                color: #fff;
                            }
                        }
                    }
                    .customTipInput{
                        width: 100%;
                        height: 2.75rem;
                        margin-top: .75rem;
                        padding: 0 1rem;
                        border: 1px solid #ccc;
                        border-radius: .5rem;
                        box-sizing: border-box;
                    }
                }
                .giftCardSection{
                    width: 100%;
                    background: #fff;
                    border-radius: .75rem;
                    padding: 1rem;
                    box-sizing: border-box;
                    margin-bottom: 1rem;
                    .giftCardModeTabs{
                        display: flex;
                        gap: .5rem;
                        margin-bottom: 1rem;
                        .giftCardModeTab{
                            flex: 1;
                            min-height: 2.5rem;
                            border: 1px solid #CCCCCC;
                            border-radius: .5rem;
                            background: #fff;
                            color: #666;
                            font-size: .8125rem;
                            padding: .5rem;
                            &.active{
                                border-color: #1E3C3E;
                                background: #1E3C3E;
                                color: #fff;
                            }
                        }
                    }
                    .directGiftCardFields{
                        display: flex;
                        flex-direction: column;
                        gap: .75rem;
                        .cardInput{
                            width: 100%;
                            height: 2.75rem;
                            border: 1px solid #CCCCCC;
                            border-radius: .5rem;
                            outline: none;
                            padding: 0 1rem;
                            font-size: .875rem;
                            background: #fff;
                            &::placeholder{
                                color: #999;
                            }
                        }
                        .directGiftCardHint{
                            color: #777;
                            font-size: .75rem;
                            line-height: 1.4;
                        }
                    }
                    .errorTip{
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        margin-top: .75rem;
                        color: #E8A740;
                        font-size: .875rem;
                        .errorIcon{
                            width: 1rem;
                            height: 1rem;
                            border: 1px solid #E8A740;
                            border-radius: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-right: .375rem;
                            font-size: .75rem;
                        }
                    }
                    .giftCardTipNotice{
                        margin-top: .75rem;
                        color: #777;
                        font-size: .75rem;
                        line-height: 1.4;
                    }
                    .selectFromWallet{
                        width: 100%;
                        height: 2.75rem;
                        border: 1px solid #CCCCCC;
                        border-radius: .5rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-top: 1rem;
                        color: #333;
                        font-size: .875rem;
                        cursor: pointer;
                        background: #fff;
                    }
                    .balanceInfo{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-top: .75rem;
                        padding: .75rem 1rem;
                        background: #F8F8F8;
                        border-radius: .5rem;
                        border: 1px solid #E5E8E6;
                        .balanceLabel{
                            font-size: .875rem;
                            font-weight: 600;
                            color: #1E3C3E;
                        }
                        .selectedCardNumber{
                            color: #333;
                            font-size: .875rem;
                            margin-bottom: .25rem;
                        }
                    }
                }
            }
        }
    }
    // 卡包弹窗样式
    .walletPopup{
        padding: 1rem;
        .walletTitle{
            font-size: 1rem;
            font-weight: 500;
            color: #333;
            text-align: left;
            margin-bottom: 1rem;
            padding-top: .5rem;
        }
        .walletLoading,
        .walletEmpty{
            text-align: center;
            color: #999;
            padding: 2rem 0;
        }
        .walletList{
            max-height: 55vh;
            overflow-y: auto;
        }
        .walletCard{
            border-radius: 1rem;
            padding: 1.25rem;
            margin-bottom: 1rem;
            color: #fff;
            position: relative;
            overflow: hidden;
            // 绿色卡片
            &.green-card{
                background: linear-gradient(135deg, #1a4d3e 0%, #2d6b5a 50%, #1a4d3e 100%);
            }
            // 蓝色卡片
            &.blue-card{
                background: linear-gradient(135deg, #1e3a5f 0%, #2a4a6d 50%, #1e3a5f 100%);
            }
            // 发光效果
            &::before {
                content: '';
                position: absolute;
                top: 30%;
                left: 20%;
                width: 120px;
                height: 120px;
                background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%);
                pointer-events: none;
            }
            .cardHeader{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: .75rem;
                position: relative;
                z-index: 1;
                .cardTag{
                    font-size: .875rem;
                    font-weight: 500;
                    color: rgba(255,255,255,0.9);
                }
                .cardCopy{
                    width: 2rem;
                    height: 2rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    opacity: 0.8;
                    &:active{
                        opacity: 1;
                    }
                }
            }
            .cardNumber{
                font-size: 1.25rem;
                font-weight: 600;
                letter-spacing: 2px;
                margin-bottom: 1rem;
                position: relative;
                z-index: 1;
            }
            .cardShopName{
                font-size: 1rem;
                font-weight: 600;
                margin-bottom: .25rem;
                position: relative;
                z-index: 1;
            }
            .cardAddress{
                font-size: .75rem;
                color: rgba(255,255,255,0.7);
                margin-bottom: 1rem;
                position: relative;
                z-index: 1;
            }
            .cardBottom{
                display: flex;
                align-items: center;
                justify-content: space-between;
                position: relative;
                z-index: 1;
                .cardLabel{
                    font-size: .75rem;
                    color: rgba(255,255,255,0.8);
                }
                .cardAmount{
                    font-size: 1.5rem;
                    font-weight: 700;
                }
            }
        }
    }
</style>
